import { NavigateFunction } from "react-router-dom";

export const formatPaths = ({ navigate, state, path, id }: { navigate: NavigateFunction; state: any; id?: string; path: string }) => {
    const folioDetail = state.replaceRoutes?.folio_detail
    const listFolio = state.replaceRoutes?.search_folio
    return [
        {
            id: 'schedule',
            label: path,
            navigate: () => { navigate(`/dashboard/${path}`) }
        },
        {
            id: 'scheduleList',
            label: 'scheduleDetail',
            navigate: () => { navigate(`/dashboard/${path}/detail/${state?.id}`, { state: state }) }
        },
        {
            id: 'reportFolioList',
            label: 'reportFolioList',
            navigate: () => { navigate(`/dashboard/${path}/report-folio-list${listFolio.search}`, { state: state }) }
        },
        {
            id: 'reportFolioList',
            label: 'detailReportFolio',
            navigate: () => { navigate(`/dashboard/${path}/report-folio/${id}${folioDetail.search}`, { state: state }) }
        },
        {
            id: 'reportFolioList',
            label: 'reassign-userEdit',
            navigate: () => { }
        },
    ]
}